"use client"

import Image from "next/image";
import CRMask from "../CRMask";
import CRAbout from "./CRAbout";
import CRMedia from "./CRMedia";
import CRAboutImgWrap from "./CRAboutImgWrap";

// about and media

const CRAboutAndMedia = () =>{

    return(
        <div className="about-and-media max-w-[1440px] relative w-full h-full 
            flex flex-col items-center 
            asm:h-full usm:pt-[250px]
        ">
            <div className="about-top-wrap h-full w-[1440px] usm:w-full usm:h-auto">
                <CRAbout />  {/* about */}
            </div>

            {/* 人物及遮罩 */}
            <CRAboutImgWrap />

            <CRMedia />  {/* media */}
        </div>
    )
}

export default CRAboutAndMedia;